import { useSearchParams } from "react-router-dom";
import { PipelineBoard, DELIVERY_STAGES } from "./Leads";

const TABS = { "All current": DELIVERY_STAGES, Planning: ["Planning"], Filming: ["Filming"], Editing: ["Editing"], "In revision": ["In revision"], Completed: ["Completed"] };

export default function Projects() {
  const [sp, setSp] = useSearchParams();
  const tab = TABS[sp.get("tab")] ? sp.get("tab") : "All current";
  return (
    <div data-testid="admin-projects">
      <h1 className="font-heading font-extrabold text-3xl text-brand-purpleDeep">Projects</h1>
      <p className="text-brand-purpleDeep/50 text-sm mt-1">Delivery only — jobs moved to Won in the Pipeline land in Planning.</p>
      <div className="mt-4 mb-4 flex flex-wrap gap-2">{Object.keys(TABS).map((t) => <button key={t} onClick={() => setSp(t === "All current" ? {} : { tab: t })} className={`px-3 py-1.5 rounded-lg text-sm font-medium ${tab === t ? "bg-brand-purple text-white" : "bg-white border border-border"}`} data-testid={`proj-tab-${t}`}>{t}</button>)}</div>
      <PipelineBoard key={tab} scope="projects" stages={TABS[tab]} />
    </div>
  );
}
